import { render, staticRenderFns } from "./PushFormModel.vue?vue&type=template&id=6f637610&scoped=true"
import script from "./PushFormModel.vue?vue&type=script&lang=js"
export * from "./PushFormModel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f637610",
  null
  
)

export default component.exports